module.exports = __webpack_public_path__ + "static/media/globe.fc84d94f.svg";